import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// Dialog
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';


export default function App() {
    const [open, setOpen] = useState(false);
    const [DialogDesc, SetDialogDesc] = useState({
        title: '',
        desc: '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Swiper
                breakpoints={{
                    1024: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    375: {
                        slidesPerView: 3,
                    },
                }}
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper"
                style={{
                    margin: '30px 0',
                }}>
                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Html',
                        desc: 'HTML (HyperText Markup Language) is a markup language used to create the structure of web pages, defining elements and content like text, images, and links. It serves as the foundation for web design and development, facilitating the organization and formatting of information.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/html.png')} />
                    {/* <p>Html5</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Css3',
                        desc: 'CSS (Cascading Style Sheets) is a stylesheet language used to describe the presentation of a document written in HTML or XML. It enables developers to control the layout, colors, fonts, and overall aesthetics of web pages, enhancing the visual appearance and user experience.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/CSS3.png')} />
                    {/* <p>Css</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'JavaScript',
                        desc: 'JavaScript (JS) is a versatile programming language commonly used for adding interactivity and dynamic behavior to web pages. It enables developers to create responsive user interfaces, manipulate the DOM, handle events, and communicate with servers, making web applications more engaging and functional.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/js.png')} />
                    {/* <p>Java Script</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Json',
                        desc: 'JSON (JavaScript Object Notation) is a lightweight data interchange format that is easy for humans to read and write, and easy for machines to parse and generate. It is often used to transmit data between a server and a web application as an alternative to XML, utilizing a simple key-value pair structure for representing complex data.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/json-file.png')} />
                    {/* <p>Json</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Api',
                        desc: 'An API (Application Programming Interface) is a set of rules and protocols that allows different software applications to communicate with each other. It defines the methods and data formats that applications can use to request and exchange information, enabling developers to integrate external services, access data, and build functionality without needing to understand the underlying code.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/api.png')} />
                    {/* <p>Api</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Bootstrap',
                        desc: 'Bootstrap is a popular open-source front-end framework that provides a collection of CSS and JavaScript components for building responsive and mobile-first web applications. It simplifies web development by offering pre-designed templates, grid layouts, and UI components, enabling developers to create visually appealing and consistent interfaces quickly and efficiently.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/bootstrap.png')} />
                    {/* <p>Bootstrap</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Tailwind',
                        desc: 'Tailwind CSS is a utility-first CSS framework that enables developers to create custom designs directly in their HTML by using predefined utility classes. Unlike traditional CSS frameworks, Tailwind promotes a component-based approach, allowing for rapid prototyping and consistent styling without writing custom CSS, making it highly flexible and efficient for building modern web applications.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/tailwind.png')} />
                    {/* <p>Tailwind</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Git',
                        desc: 'Git is a distributed version control system that allows multiple developers to collaborate on projects by tracking changes in files and coordinating work. It enables users to create repositories, manage versions, and facilitate branching and merging, making it easy to revert to previous states, collaborate on code, and maintain project history efficiently.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/git.png')} />
                    {/* <p>Git</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Github',
                        desc: 'GitHub is a web-based platform that uses Git for version control and collaboration, allowing developers to host and manage their code repositories. It provides tools for issue tracking, code review, and collaboration, making it easier for teams to work together on projects. GitHub also supports open-source development, enabling users to contribute to public repositories and share their work with the community.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/github.png')} />
                    {/* <p>Github</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'React',
                        desc: 'React is an open-source JavaScript library developed by Facebook for building user interfaces, particularly single-page applications. It allows developers to create reusable UI components, manage the state efficiently, and update the user interface in response to data changes, making it easy to build dynamic and interactive web applications.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/react.png')} />
                    {/* <p>React</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Redux',
                        desc: 'Redux is a state management library for JavaScript applications, commonly used with React. It provides a predictable state container that helps manage application state in a centralized manner, enabling easier debugging and testing. Redux uses a unidirectional data flow and relies on actions and reducers to handle state changes, making it suitable for complex applications with multiple components that need to share state.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/redux.png')} />
                    {/* <p>Redux</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Firebase',
                        desc: 'Firebase is a comprehensive platform developed by Google that provides a suite of tools and services for building and managing web and mobile applications. It offers features such as real-time databases, authentication, cloud storage, hosting, and analytics, allowing developers to focus on building high-quality applications without worrying about infrastructure management. Firebase is especially popular for its ease of integration and scalability.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/firebase.png')} />
                    {/* <p>Firebase</p> */}
                </SwiperSlide>

                <SwiperSlide  onClick={() => {
                    SetDialogDesc({
                        title: 'Material-UI',
                        desc: 'MUI (Material-UI) is a popular React component library that implements Google’s Material Design principles. It provides a set of pre-designed, customizable components, such as buttons, dialogs, and navigation elements, allowing developers to create responsive and visually appealing user interfaces quickly. MUI emphasizes usability and accessibility, making it easier to build consistent and user-friendly applications.',
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/Material UI.png')} />
                    {/* <p>Mui</p> */}
                </SwiperSlide>

                <SwiperSlide onClick={() => {
                    SetDialogDesc({
                        title: 'Next Js',
                        desc: `Next.js is a React framework for building advanced web applications. It offers built-in features like automatic routing, static generation, server-side rendering, and performance optimization, making it ideal for creating fast and SEO-friendly websites.`,
                    })
                    handleClickOpen()
                }}>
                    <img loading='lazy' alt='Skill' src={require('../image/Skills/nextjs.png')} />
                    {/* <p>Next Js</p> */}
                </SwiperSlide>
            </Swiper>

            {/* Start Dialog */}
            <Dialog
                open={open}
                onClose={handleClose}
                component={"div"}
                
                data-aos-duration="500"
            >
                <DialogTitle>{DialogDesc.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{DialogDesc.desc}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
            </Dialog>
            {/* End Dialog */}
        </>
    );
}
